import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  FormControl,
} from "@material-ui/core";

import utils from "../utils";

const PasswordDialog = ({ open, handleUpdate, handleCancel }) => {
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");

  const cancel = (event) => {
    handleCancel();
    event.preventDefault();
  };

  const updatePassword = (event) => {
    handleUpdate(password1);
    event.preventDefault();
  };

  const resetState = () => {
    setPassword1("");
    setPassword2("");
  };

  const bothEntered = password1 !== "" && password2 !== "";
  const mismatch = bothEntered && password1 !== password2;
  const tooWeak =
    bothEntered && !mismatch && !utils.validatePassword(password1);
  const canSubmit = bothEntered && !mismatch && !tooWeak;

  return (
    <Dialog
      open={open}
      TransitionProps={{ onEnter: resetState }}
      aria-labelledby="form-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
      <DialogContent>
        <DialogContentText>Enter your new password.</DialogContentText>
        <FormControl fullWidth>
          <TextField
            autoFocus
            value={password1}
            margin="dense"
            id="password1"
            label="New password"
            type="password"
            variant="outlined"
            onChange={(event) => setPassword1(event.target.value)}
            helperText="Password must be at least 8 characters long"
            fullWidth
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            value={password2}
            margin="dense"
            id="password2"
            label="Confirm password"
            type="password"
            variant="outlined"
            onChange={(event) => setPassword2(event.target.value)}
            fullWidth
            error={mismatch || tooWeak}
            helperText={
              mismatch
                ? "Your passwords do not match."
                : tooWeak
                ? "Password must be at least 8 characters long."
                : ""
            }
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel}>Cancel</Button>
        <Button
          onClick={updatePassword}
          color="primary"
          variant="contained"
          disabled={!canSubmit}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordDialog;
